export const ErrorsConstantsAvoid = [
  'CONTACT_ALREADY_EXISTS',
  'NOT_FOUND_PIX_KEY',
  'jwt malformed',
  'USER_NOT_VALID_OR_INEXISTENT',
];
